module.exports = __webpack_public_path__ + "static/images/help_yh.c806978.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step/help_yh.png
// module id = cCpf
// module chunks = 1